<div class="store-export-page-container container" [formGroup]="form">
  <p>{{ 'STORE_EXPORT.DESCRIPTION' | translate }}</p>
  <h3 class="mat-h3 color-primary">{{ 'STORE_EXPORT.OPTIONAL_COMPONENTS' | translate }}</h3>
  <div fxLayout="column">
    <mat-checkbox formControlName="includeRatings" color="primary">{{ 'STORE_EXPORT.INCLUDE_RATINGS' | translate }}</mat-checkbox>
    <mat-checkbox formControlName="includeServices" color="primary">{{ 'STORE_EXPORT.INCLUDE_SERVICES' | translate }}</mat-checkbox>
  </div>
</div>
